var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconQuoteOpening = function SvgIconQuoteOpening(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 5.357A5.356 5.356 0 0 1 5.357 0h.357c.79 0 1.429.638 1.429 1.429 0 .79-.639 1.428-1.429 1.428h-.357c-1.38 0-2.5 1.12-2.5 2.5v.357h2.857a2.86 2.86 0 0 1 2.857 2.857v2.858a2.86 2.86 0 0 1-2.857 2.857H2.857A2.86 2.86 0 0 1 0 11.429V5.357m11.429 0A5.356 5.356 0 0 1 16.786 0h.357c.79 0 1.428.638 1.428 1.429 0 .79-.638 1.428-1.428 1.428h-.357c-1.38 0-2.5 1.12-2.5 2.5v.357h2.857A2.86 2.86 0 0 1 20 8.571v2.858a2.86 2.86 0 0 1-2.857 2.857h-2.857a2.86 2.86 0 0 1-2.857-2.857V5.357"
  })));
};
export default SvgIconQuoteOpening;